import { createStyles, makeStyles } from '@hawkins/styles';
var generateThemeVariables = function (theme) {
    var hawkins = theme.hawkins;
    if (hawkins.theme === 'light') {
        return {
            colorBackground: hawkins.ui.backgroundColor5,
            borderColor: 'transparent',
        };
    }
    return {
        colorBackground: hawkins.elevation.backgroundColor3,
        borderColor: hawkins.elevation.borderColorElevated,
    };
};
export var floatingUiStyles = function (theme) {
    var hawkinsVariables = theme.hawkinsVariables;
    var themeVariables = generateThemeVariables(theme);
    return createStyles({
        /** Class name to apply to the root of the component */
        root: {
            position: 'absolute',
            zIndex: hawkinsVariables.zIndexes.modal,
        },
        /** Class name to apply to the root when `styled` is true */
        rootStyled: {
            backgroundColor: themeVariables.colorBackground,
            borderColor: themeVariables.borderColor,
            borderRadius: hawkinsVariables.borderRadius.borderRadius0,
            borderStyle: 'solid',
            borderWidth: 1,
            boxShadow: theme.hawkins.elevation.boxShadow2,
            color: theme.hawkins.persistent.textColorWhiteRegular,
            fontSize: hawkinsVariables.fontSizes.fontSize2,
            fontWeight: 600,
            padding: "".concat(hawkinsVariables.spacings.space1, " ").concat(hawkinsVariables.spacings.space2),
        },
        /** Class name applied to the component if placement contains "bottom". */
        placementBottom: {},
        /** Class name applied to the component if placement contains "left". */
        placementLeft: {},
        /** Class name applied to the component if placement contains "right". */
        placementRight: {},
        /** Class name applied to the component if placement contains "top". */
        placementTop: {},
        /** Class name to apply to the arrow */
        arrow: {
            backgroundColor: themeVariables.colorBackground,
            height: 8,
            position: 'absolute',
            transform: 'rotate(45deg)',
            width: 8,
        },
        /** Class name to apply to the wrapper element when the elevated prop is enabled */
        elevated: {
            boxShadow: theme.hawkins.elevation.boxShadow2,
        },
    });
};
export var useFloatingUiStyles = makeStyles(floatingUiStyles, { name: 'Hawkins-FloatingUI' });
